var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.29 3.86002L1.82002 18C1.64539 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3438 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23675 20.5468 2.53773 20.7239C2.83871 20.901 3.18082 20.9962 3.53002 21H20.47C20.8192 20.9962 21.1613 20.901 21.4623 20.7239C21.7633 20.5468 22.0127 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3438 22.448 18.9945C22.4471 18.6453 22.3547 18.3024 22.18 18L13.71 3.86002C13.5318 3.56613 13.2807 3.32314 12.9812 3.15451C12.6817 2.98587 12.3438 2.89728 12 2.89728C11.6563 2.89728 11.3184 2.98587 11.0188 3.15451C10.7193 3.32314 10.4683 3.56613 10.29 3.86002Z",
    stroke: "#D92B2B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8391 8.07271L12.6985 14.2346H11.3263L11.1899 8.07271H12.8391ZM12.0124 16.8937C11.7539 16.8937 11.5323 16.8028 11.3476 16.621C11.1658 16.4392 11.0749 16.2176 11.0749 15.9562C11.0749 15.7006 11.1658 15.4818 11.3476 15.3C11.5323 15.1182 11.7539 15.0273 12.0124 15.0273C12.2652 15.0273 12.484 15.1182 12.6686 15.3C12.8561 15.4818 12.9499 15.7006 12.9499 15.9562C12.9499 16.1295 12.9059 16.2872 12.8178 16.4292C12.7326 16.5713 12.6189 16.6849 12.4769 16.7702C12.3377 16.8525 12.1828 16.8937 12.0124 16.8937Z",
    fill: "#D92B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/errorTriangle.09d8057105aef89e053cb14a63b561f5.svg";
export { ForwardRef as ReactComponent };